/**
 * Element management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class ElementManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async getElementById(projectUuid: string, elementId: string): Promise<Record<string, any>> {
    return this.session.get(`/api/element/get/${elementId}`, { params: { projectUuid } });
  }

  async createElement(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/element/create', { data });
  }

  async updateElement(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/element/update', { data });
  }

  async deleteElement(projectUuid: string, uuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/cdp/element/delete/${uuid}`, { params: { projectUuid } });
  }

  async getElementTree(projectUuid: string, witchDeviceData?: boolean): Promise<Record<string, any>[]> {
    return this.session.get('/api/element/queryTree', { params: { projectUuid, witchDeviceData } });
  }

  async getElementTreeByParent(projectUuid: string, parentUuid: string, witchDeviceData?: boolean): Promise<Record<string, any>[]> {
    return this.session.get('/api/element/queryTreeByParent', { params: { projectUuid, parentUuid, witchDeviceData } });
  }

  async modifyDeviceRel(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/element/modifyDeviceRel', { data });
  }
}
